import Vue from "vue";
import VueRouter from "vue-router";

import LoginComponent from "@/components/utils/LoginComponent.vue";
import HomePage from "@/components/pages/HomePage.vue";
import AlarmsPage from "@/components/pages/AlarmsPage.vue";
import HistoryPage from "@/components/pages/HistoryPage.vue";
import TelevisionView from "@/components/views/TelevisionView.vue";
import EstadisticasView from "@/components/views/EstadisticasView.vue";
import LinesList from "@/components/LinesList.vue";
import RegisterComponent from "@/components/utils/RegisterComponent.vue";
import VariablesView from "@/components/views/VariablesView.vue";
import RamosTankView from "@/components/views/RamosTankView.vue"; 
import ArmariosView from "@/components/views/ArmariosView.vue";
import TemperaturasView from "@/components/views/TemperaturasView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomePage,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Página principal",
          content: "Página principal de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/login",
    name: "login",
    component: LoginComponent,
    meta: {
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Login",
          content: "Página de login de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/register",
    name: "register",
    component: RegisterComponent,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Registro",
          content: "Página de registro de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/alarms",
    name: "alarmas",
    component: AlarmsPage,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Alarmas",
          content: "Página de alarmas de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/history/:page_index",
    name: "history",
    component: HistoryPage,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Histórico",
          content: "Página de histórico de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/linea",
    name: "lineas",
    component: LinesList,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Líneas",
          content: "Listado de línea de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/linea/:line_id",
    name: "linea",
    component: TelevisionView,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Línea",
          content: "Página de línea de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/estadisticas",
    name: "estadisticas",
    component: EstadisticasView,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Estadísticas",
          content: "Página de estadísticas de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/tanques",
    name: "tanques",
    component: RamosTankView,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Histórico Tanques",
          content: "Página de Histórico Tanques de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/vars",
    name: "vars",
    component: VariablesView,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Variables",
          content: "Página de administrar variables de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/armarios",
    name: "armarios",
    component: ArmariosView,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Armarios",
          content: "Página de armarios de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/temps/:nave",
    name: "temperaturas",
    component: TemperaturasView,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Temperaturas",
          content: "Página de temperaturas de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/temphum/:nave",
    name: "temperaturas y humedades",
    component: TemperaturasView,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Temperaturas y Humedades",
          content: "Página de temperaturas y humedades de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/analizadores/:nave",
    name: "analizadores",
    component: TemperaturasView,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Analizadores",
          content: "Página de Analizadores de red eléctirca de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title} - ${to.meta.metaTags[0].name}`;
  }

  const loggedIn = localStorage.getItem("token");
  if (to.matched.some((record) => record.meta.requiresAuth) && !loggedIn) {
    next({ name: "login" });
  } else {
    next();
  }
});

export default router;
